import http from "./http-common";

class CompanyConfigDataService {
  getAll() {
    return http.get("/companyConfig");
  }

  update(data) {
    return http.put("/companyConfig", data);
  }

  getLogo(id) {
    return http.get(`/companyConfig/${id}/logo`);
  }
  uploadLogo(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    return http.post(`/companyConfig/${id}/logo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  deleteLogo(id) {
    return http.delete(`/companyConfig/${id}/logo`);
  }

  getMiniLogo(id) {
    return http.get(`/companyConfig/${id}/minilogo`);
  }
  uploadMiniLogo(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    return http.post(`/companyConfig/${id}/minilogo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  deleteMiniLogo(id) {
    return http.delete(`/companyConfig/${id}/minilogo`);
  }
}

export default new CompanyConfigDataService();